import NiceModal from "@ebay/nice-modal-react";
import { medusaRequester, requester, storeRequester } from "App";
import clsx from "classnames";
import CustomIcon from "components/icons/CustomIcon";
import P from "components/P";
import SkeletonImage from "components/skeleton/SkeletonImage";
import SkeletonText from "components/skeleton/SkeletonText";
import Inline from "layouts/container/Inline";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalFlex from "layouts/flex/VerticalFlex";
import Center from "layouts/wrapper/Center";
import PaddingWrapper from "layouts/wrapper/PaddingWrapper";
import SquareWrapper from "layouts/wrapper/SquareWrapper";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { addCommas } from "shared/utils/Utils";
import style from "./NormalProductCard.module.scss";
import { AuthContext } from "providers/AuthProvider";
import medusaClient from "shared/MedusaClient";
// import { getCustomer } from "shared/medusa/action";
import HorizontalCard from "./HorizontalCard";
import EventSticker from "./sticker/EventSticker";
import Dummy from "components/Dummy";
import cartIcon from "resources/img/category/cart.png";
import { BrowserDetectContext } from "providers/BrowserEventProvider";


function NoneCartProductCard(props) {
    const { data, type, skeleton } = props;
    const { userName } = useContext(AuthContext);
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [wish, setWish] = useState(false);
    const dispatch = useDispatch();
    const products = useSelector((state) => state.wish.products, shallowEqual);
    const {isMobile} = useContext(BrowserDetectContext)




    const onProductClick = () => {
        navigate(`/product/detail/${data.id}`);
    }
    const addCartButtonClick = (e) => {
        e.stopPropagation();
        NiceModal.show("mobileAddCart", { product: data });
    }
    

    useEffect(() => {
        if (products && data) {
            let wishYn = false;

            products.map((wish) => {
                if (wish.productId === data.id && wish.userId) {
                    wishYn = wish.wishYn;
                }
            });
            setWish(wishYn);
        }
    }, [products]);

    useEffect(() => {
        if (products && data) {
            let wishYn = false;

            products.map((wish) => {
                if (wish.productId === data.id && wish.userId) {
                    wishYn = wish.wishYn;
                }
            });
            setWish(wishYn);
        }
    }, [data]);


    return (
        <div
            className={clsx(style.wrap, { [style.horizontal]: type === "horizontal" })}
            style={{padding: isMobile ? "10px" : null}}
        >
            {
                type === "horizontal"
                    ?
                    <HorizontalCard
                        skeleton={skeleton}
                        data={data}
                        onProductClick={onProductClick}
                        addCartButtonClick={addCartButtonClick}
                        rank={props.rank}
                    />
                    :
                    <VerticalFlex >
                        <FlexChild borderBottomRightRadius={"0"}>
                            {
                                skeleton ?
                                    <div className={style.thumbnail} style={{ backgroundColor: "#ebebeb" }}>
                                        <SquareWrapper>
                                            {
                                                skeleton ? <SkeletonImage width={100} />
                                                    : <img className={style.image} src={data.thumbnail} alt={""} />
                                            }
                                        </SquareWrapper>
                                    </div>
                                    :
                                    <div className={style.thumbnail} style={{ backgroundColor: `${data.bgColor}11` }}>

                                        <SquareWrapper>
                                            {
                                                props.rank &&
                                                <div className={style.indexCircle}>{props.rank}</div>
                                            }
                                            <img onClick={onProductClick} className={style.image} src={data.thumbnail} alt={""} />
                                        </SquareWrapper>
                                    </div>
                            }
                        </FlexChild >
                        <FlexChild height={"fit-content"} backgroundColor={"white"}>
                            <PaddingWrapper padding={"15px 0 0 0"}>
                                {
                                    skeleton ?
                                        <Center width={"100%"} textAlign={"left"}>
                                            <SkeletonText width={50} size={16} />
                                            <SkeletonText width={50} size={16} />
                                            <SkeletonText width={50} size={16} />
                                            <Inline>
                                                <SkeletonText width={50} size={10} />
                                                <SkeletonText width={50} size={10} />
                                                <SkeletonText width={50} size={10} />
                                            </Inline>
                                            <SkeletonText width={50} size={10} />
                                            <SkeletonText width={50} size={10} />
                                        </Center>
                                        :
                                        <Center width={"100%"} maxWidth={200} textAlign={"left"}>
                                            <P width={isMobile && "150px"} textHover cursor onClick={onProductClick} ellipsis size={isMobile ? 16 :20} weight={700} whiteSpace={'nowrap'} overFlow={'hidden'} textOverflow={'ellipsis'}>{data.title}</P>

                                            <HorizontalFlex gap={10} justifyContent={"flex-end"}>
                                                {
                                                    data.currentPrice && userName &&
                                                    <FlexChild justifyContent={"flex-start"}>
                                                        <P textAlign={"right"} size={"14px"} weight={"bold"} color={"red"}>{100 - data.currentPrice / data.price * 100}%</P>
                                                    </FlexChild>
                                                }
                                                {/* products로 받을 때 */}
                                                {data && data.variants && data.variants.length > 0 &&
                                                    <FlexChild justifyContent={"flex-start"}>
                                                        <P textHover cursor onClick={onProductClick} textAlign={"left"} size={isMobile ? 16 :20} weight={"bold"} color={"rgba(89, 87, 87, 1)"} textDecoration={data.currentPrice && "line-through"}>&#8361;
                                                            {
                                                                // userName ? 
                                                                addCommas(data.variants[0]?.prices[0]?.amount)
                                                                //  : "-"
                                                            }</P>
                                                    </FlexChild>
                                                }
                                            </HorizontalFlex>
                                            <Dummy height={"5px"} />
                                            {data.events && data.events.length > 0 ?
                                                <EventSticker events={data.events} />
                                                :
                                                <P height={"20px"} ellipsis size={12} weight={"900"} color={"red"}></P>
                                            }
                                        </Center>
                                }
                            </PaddingWrapper>
                        </FlexChild>
                    </VerticalFlex >
            }
        </div>
    );
}

export default NoneCartProductCard;
